import { IBadgeProps } from "./Badge";

export const View = ({
  title,
  statusColor,
  indicatorComponent,
  indicatorColor,
  hideIndicator,
  indicatorSize = "md",
  text,
  largeFont,
  className,
  contentContainerClassName,
}: IBadgeProps) => {
  return (
    <span
      title={title}
      className={`badge-container ${statusColor}-badge--color ${
        largeFont ? "badge-font--large" : ""
      } ${className}`}
    >
      <span className={contentContainerClassName}>{text}</span>

      {hideIndicator ? (
        <></>
      ) : (
        indicatorComponent ?? (
          <span
            className={`badge-status--indicator ${
              indicatorColor || statusColor
            }-indicator--color indicator-size--${indicatorSize}`}
          />
        )
      )}
    </span>
  );
};
